import PropTypes from "prop-types"
import cc from "classcat"

const SectionHeader = ({ children, theme, style }) => (
  <div
    className={cc([
      "my-6 whitespace-pre-line text-center font-display text-3xl font-bold leading-9 md:text-5xl md:leading-tight",
      {
        "text-white": theme === "light",
      },
    ])}
    style={style}
  >
    {children}
  </div>
)

SectionHeader.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SectionHeader
